 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		17: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		17: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "javascripts/chunks/" + {"0":"ab0fcebb0c2f26152095","1":"e722e7b63ec7c49331b4","2":"c00ed73bbef0ff7d71f2","3":"fd19af3abce389324456","4":"24401dc01ff188ea7fe6","5":"61c6f6781bfa9c7e9624","6":"33c0e0e2addf7f626c37","7":"b293e1b4a9b36c6f2237","8":"0c7adcdb347447c4fd34","9":"8d1a60ad62987cd1c63e","10":"b433797886f86270e38e","11":"da20548880b57985d52d","12":"3d595d7dccdacbe05c71","13":"0c6266f873ec54e1db0b","14":"e86c40a04e8fec05b0fb","15":"3221cccba0f26ab05f10","16":"e60ce2da4e4fa5444a69","18":"d0f645d532c67ce56250","19":"5b3c309db5c0696d748a","20":"08f05f2f730186eec1f3","21":"7fa72470c8b2da9eebab","22":"4976db87a4bc7977c649","23":"4f96b4d981d872887660","24":"0ca3580849f4d2b6915d","25":"b873f4a27f63b65f801d","26":"3a97deac9cf5f59b5074","27":"944dc16548c0a0af6f5f","28":"6a1483f71e18325d857a","29":"4c7a2c578e77fe5a5ea2","30":"0285c56debdcf5e4cdac","31":"095e9a816abf908a8647","32":"efb6b72c28628aaa84bf","33":"1ad6bd5c79dd60538881","34":"1a114b9bf74fe714a29f","35":"6ba75c58f446703c0b05","36":"f3e0864fa5b9674d7a1b","37":"0711b93d61646c673016","38":"e7fe5e67f12298678afc","39":"5556c5388040bacd9417","40":"8cbefe3c2b75ebf20348","41":"2d1adee2c819b4bfe7f3","42":"8bfaabad3063a1cb0d74","43":"1ce3a0ad4e6c7513d531","44":"4e6e086e7948aee58b13","45":"21cc71d95c5da4e1dff8"}[chunkId] + "." + ({"2":"chart~investment-advice","3":"vendors~business~scrolling-text","4":"vendors~chart~investment-advice","5":"accordion","6":"block-media","7":"business","8":"chart","9":"contact","10":"faq-container","11":"fixing-rates","12":"form","13":"gallery","14":"investment-advice","15":"investor-profile","16":"inxmail","18":"menubar","19":"modal","20":"movingGradient","21":"navigation","22":"notification","23":"popup","24":"quote","25":"scrolling-text","26":"search","27":"stage-home","28":"tabs","29":"tombstones","30":"tooltip","31":"top-btn","32":"vendors~form","33":"vendors~gallery","34":"vendors~investment-advice","35":"vendors~navigation","36":"vendors~quote","37":"vendors~scrolling-text","38":"vendors~search","39":"vendors~tabs","40":"vendors~tooltip","41":"video"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"32":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "chunks/" + {"0":"ab0fcebb0c2f26152095","1":"e722e7b63ec7c49331b4","2":"c00ed73bbef0ff7d71f2","3":"fd19af3abce389324456","4":"24401dc01ff188ea7fe6","5":"61c6f6781bfa9c7e9624","6":"33c0e0e2addf7f626c37","7":"b293e1b4a9b36c6f2237","8":"0c7adcdb347447c4fd34","9":"8d1a60ad62987cd1c63e","10":"b433797886f86270e38e","11":"da20548880b57985d52d","12":"3d595d7dccdacbe05c71","13":"0c6266f873ec54e1db0b","14":"e86c40a04e8fec05b0fb","15":"3221cccba0f26ab05f10","16":"e60ce2da4e4fa5444a69","18":"d0f645d532c67ce56250","19":"5b3c309db5c0696d748a","20":"08f05f2f730186eec1f3","21":"7fa72470c8b2da9eebab","22":"4976db87a4bc7977c649","23":"4f96b4d981d872887660","24":"0ca3580849f4d2b6915d","25":"b873f4a27f63b65f801d","26":"3a97deac9cf5f59b5074","27":"944dc16548c0a0af6f5f","28":"6a1483f71e18325d857a","29":"4c7a2c578e77fe5a5ea2","30":"0285c56debdcf5e4cdac","31":"095e9a816abf908a8647","32":"efb6b72c28628aaa84bf","33":"1ad6bd5c79dd60538881","34":"1a114b9bf74fe714a29f","35":"6ba75c58f446703c0b05","36":"f3e0864fa5b9674d7a1b","37":"0711b93d61646c673016","38":"e7fe5e67f12298678afc","39":"5556c5388040bacd9417","40":"8cbefe3c2b75ebf20348","41":"2d1adee2c819b4bfe7f3","42":"8bfaabad3063a1cb0d74","43":"1ce3a0ad4e6c7513d531","44":"4e6e086e7948aee58b13","45":"21cc71d95c5da4e1dff8"}[chunkId] + "." + chunkId + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 84);
